<section class="page">
	<header class="page-header">
		<h2>Créer une cartouche</h2>
	</header>
@if (success) {
	<div class="success">{{ success }}</div>
}
@if (error) {
	<div class="error">{{ error }}</div>
}
	<form class="panel" (ngSubmit)="create()">
		<label for="nom">Nom</label>
		<input id="nom" name="nom" [(ngModel)]="form.nom" maxlength="255" />
		<label for="lot_cartouche_id">Lot cartouche</label>
		<select id="lot_cartouche_id" name="lot_cartouche_id" [(ngModel)]="form.lot_cartouche_id">
			<option [ngValue]="undefined">Sélectionner un lot</option>
@for (lot of lots; track lot.id) {
			<option [ngValue]="lot.id">{{ lot.nom }}</option>
}
		</select>
		<label for="chimie_id">Chimie</label>
		<select id="chimie_id" name="chimie_id" [(ngModel)]="form.chimie_id">
			<option [ngValue]="undefined">Sélectionner une chimie</option>
@for (chimie of chimies; track chimie.id) {
			<option [ngValue]="chimie.id">{{ chimie.nom }}</option>
}
		</select>
		<label>
			<input type="checkbox" [(ngModel)]="form.utilise" name="utilise" /> Utilisée ou réservée
		</label>
		<label>
			<input type="checkbox" [(ngModel)]="form.inutilisable" name="inutilisable" /> Inutilisable
		</label>
		<div class="actions">
			<button type="submit" [disabled]="loading">Créer</button>
		</div>
	</form>
</section>
